export const isUndefinedOrEmpty = (value: string | undefined): boolean => {
	return typeof value === "undefined" || isEmpty(value);
};

export const isEmpty = (value: string = ""): boolean => {
	return /^\s*$/.test(value);
};
export const isNotBlankString = (item: any): boolean => {
	if (typeof item === "string") {
		item = item.trim();
		if (0 in new Object(item)) {
			return true;
		}
	}
	return false;
};

export const fixedIntegerBitNumber = function(value, bit = 2) {
	if (typeof value === "number") {
		value = `${value}`;
	}
	let added: any[] = [];
	for (let i = 0; i < bit - value.length; i++) {
		added.push(0);
	}
	return `${added.join("")}${value}`;
};

export const splitWithSymbol = function(str: number | string, splitSymbol = ",", bit = 3) {
	const results: string[] = [];
	if (typeof str !== "string") {
		str = `${str}`;
	}
	let times = 0;

	while (true) {
		let begin = (times + 1) * -1 * bit;
		let end = times === 0 ? str.length : times * -1 * bit;
		let res = str.slice(begin, end);
		if (res === "") {
			break;
		}
		results.unshift(res);
		times++;
	}
	return results.join(splitSymbol);
};

export const oneManyWords = (num: number, oneWords: string, manyWords: string) =>
	num === 1 ? oneWords : manyWords;

export const mustHaveWords = (srcWords: string, words: string, gap = " ") => {
	return srcWords.includes(words)
		? `${srcWords.replace(words, "").trim()}${gap}${words}`
		: `${srcWords}${gap}${words}`;
};
